export default {
  menu: 'Turnover',
  title: 'Turnover',
  dynamicTitle: '{name} Turnover',

  table: {
    header: {
      row: 'Row',
      docNumber: 'Document number',
      name: 'Title',
      image: 'Photo',
      date: 'Date',
      barcode: 'Barcode',
      code: 'Code',
      category: 'Category',
      variant: 'Variable',
      storeroom: 'Storeroom',
      quantity: 'Number',
      unitPrice: 'Unit amount',
      description: 'Documents',
      price: 'Amount',
      balance: 'Inventory',
      status: 'Status'
    }
  },

  statusMapper: {
    sent: 'Posted',
    onWay: 'On way',
    received: 'Receipted',
    waitingToSend: 'Waiting to send'
  }
}
